import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

/**
 * RelatedPages — SEO cross-linking block shown at the bottom of thematic pages.
 *
 * Props:
 *  - items: Array<{ title: string, description: string, path: string }>
 *  - heading (optional): custom heading, defaults to a friendly fallback.
 */
const RelatedPages = ({ items, heading = 'Vous pourriez aussi être intéressée par…' }) => {
  if (!items || items.length === 0) return null;

  return (
    <section
      data-testid="related-pages-section"
      style={{
        background: 'var(--bg-section)',
        padding: '4rem 0'
      }}
    >
      <div className="container" style={{ maxWidth: '1100px' }}>
        <h2
          className="heading-2"
          style={{
            marginBottom: '2rem',
            textAlign: 'center'
          }}
        >
          {heading}
        </h2>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '1.5rem'
          }}
        >
          {items.map((item, i) => (
            <Link
              key={i}
              to={item.path}
              data-testid={`related-page-${i}`}
              className="related-card"
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '1rem',
                background: 'white',
                borderRadius: '1rem',
                padding: '1.75rem',
                border: '1px solid var(--border-light)',
                boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                textDecoration: 'none',
                color: 'inherit',
                transition: 'all 0.3s ease'
              }}
            >
              <h3
                className="heading-3"
                style={{
                  color: 'var(--text-primary)',
                  marginBottom: '0.5rem'
                }}
              >
                {item.title}
              </h3>
              <p
                className="body-medium"
                style={{
                  color: 'var(--text-secondary)',
                  flex: 1,
                  lineHeight: 1.6
                }}
              >
                {item.description}
              </p>
              <span
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  color: 'var(--accent-primary)',
                  fontWeight: 500,
                  marginTop: '0.5rem'
                }}
              >
                Découvrir
                <ArrowRight size={18} />
              </span>
            </Link>
          ))}
        </div>
      </div>

      <style>{`
        .related-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 8px 24px rgba(61, 84, 70, 0.15);
          border-color: var(--accent-primary);
        }
      `}</style>
    </section>
  );
};

export default RelatedPages;
